import store from '@/store'
import { computed, onUnmounted, watch } from '@vue/composition-api'
import { useCurrentCast } from '@/modules/casts/compositions'

// if it's undefined, it means it's the currentCast
const useCastMachinesStatus = (givenCastId: string|undefined = undefined) => {

  let subscribedCastId: null|string = null
  const { currentCastId } = useCurrentCast()
  const castId = computed(() => givenCastId ?? currentCastId.value ?? null)

  watch(castId, async (newVal, oldVal) => {
    if (newVal !== null) {
      subscribedCastId = newVal
      await store.dispatch.networkStats.subscribeNgcvpStats({ castId: newVal })
    } else if (oldVal !== null && oldVal !== undefined) {
      subscribedCastId = null
      await store.dispatch.networkStats.unsubscribeNgcvpStats(oldVal)
    }
  }, { immediate: true })

  onUnmounted(async () => {
    if (subscribedCastId === null) return
    await store.dispatch.networkStats.unsubscribeNgcvpStats(subscribedCastId)
  })

  const ngcvpStats = computed(() => {
    if (castId.value === null) return null
    return store.state.networkStats.ngcvpStats[castId.value] ?? null
  })

  return {
    ngcvpStats
  }
}

export default useCastMachinesStatus
